import { Component, Input, TemplateRef } from '@angular/core';
import { Column } from '@app/datatables/models/column';
import { CustomColumnSettings } from '@app/datatables/models/custom-column-settings';
import { DatatableComponent } from '@app/datatables/models/custom-datatable-extension';
import { DatatableComponentDefinition } from '@app/datatables/models/datatable-component-definition.interface';
import { ConfigColumns } from 'datatables.net';

const options = {
  selector: 'portal-datatable-outlet',
  templateUrl: './datatable-outlet.component.html',
  styleUrls: ['./datatable-outlet.component.scss'],
};

@Component({
  selector: 'portal-datatable-outlet',
  templateUrl: './datatable-outlet.component.html',
  styleUrls: ['./datatable-outlet.component.scss'],
  standalone: false,
})
export class DatatableOutletComponent extends DatatableComponent {
  @Input()
  public templateRef: TemplateRef<any>;

  @Input()
  public entry: any = {};
}

export const DatatableOutletComponentDefinition: DatatableComponentDefinition = {
  inputParameters: ['entry', 'templateRef'],
  render: (data, type) => {
    let result = data;

    if (type === 'display') {
      result = `<${options.selector}></${options.selector}>`;
    }

    return result;
  },
  selector: options.selector,
  type: DatatableOutletComponent,
};

/**
 * Helper to create a new Outlet column.
 */
export class OutletColumn<T> extends Column<any, T> implements CustomColumnSettings {
  public customComponent = DatatableOutletComponentDefinition;
  public defaultContent = '';
  public render = DatatableOutletComponentDefinition.render;

  constructor(
    data: string,
    private templateRef: TemplateRef<any>,
    options?: ConfigColumns
  ) {
    super(data, options);
  }

  onAfterCreate(row: T, el: DatatableOutletComponent) {
    el.templateRef = this.templateRef;
    el.entry = row;
  }
}

export function isOutletColumn<T>(column: any): column is OutletColumn<T> {
  return 'customComponent' in column && column.customComponent === DatatableOutletComponentDefinition;
}
